// Centralized pricing configuration

// ---------------------------------------------------------------------------
// Voxerface AI receptionist — the live product. Source of truth is
// marketing/README.md; keep this in sync with the Marketplace listing and the
// phone agent's system prompt.
//
// One-time setup fee plus a flat monthly. We own the ElevenLabs and Twilio
// accounts (one A2P 10DLC registration covers every client), and clients
// forward their existing number rather than taking a new one.
// ---------------------------------------------------------------------------

export const PHONE = {
  display: '(737) 732-9555',
  href: 'tel:+17377329555',
}

export const TIERS = [
  {
    id: 'starter',
    name: 'Starter',
    setup: '$69',
    setupNote: 'one-time setup',
    monthly: '$29',
    monthlyNote: 'per month to run it',
    features: [
      'Answers 24/7 — nights, weekends, mid-job',
      'Books appointments',
      'Texts you the lead: name, number, what they need',
      'Your greeting, your hours, your service area',
      'Screens spam and tire-kickers',
      'Keep your current number',
    ],
    cta: 'Call to start',
  },
  {
    id: 'pro',
    name: 'Pro',
    setup: '$199+',
    setupNote: 'one-time setup',
    monthly: 'Scoped',
    monthlyNote: 'to your call volume',
    popular: true,
    features: [
      'Everything in Starter',
      'Custom call flows built around your business',
      'Lead qualification',
      'Call routing to the right person',
      'Outbound callbacks',
      'Priced on the phone, not guessed at',
    ],
    cta: 'Call for a quote',
  },
]

export const PROMO = {
  deadline: 'Before September 30',
  headline: '30 days of free tune-ups',
  body: "Buy the setup and I'll keep adjusting it free for a month — greeting, questions, tone — until it answers exactly the way you would.",
}

// ---------------------------------------------------------------------------
// Legacy credits/subscription config. Still consumed by the dashboard, admin,
// and usePrices. Unreachable from the marketing page.
// ---------------------------------------------------------------------------

export const PLANS = {
  free: {
    id: 'free',
    name: 'Free',
    price: 0,
    credits: 0,
    features: ['Limited access', 'No credits included'],
  },
  basic: {
    id: 'basic',
    name: 'Basic',
    price: 1900, // cents
    credits: 500,
    features: [
      '500 credits/month',
      'Core features',
      'Email support',
      'Standard rate limits',
    ],
  },
  pro: {
    id: 'pro',
    name: 'Pro',
    price: 4900, // cents
    credits: 2000,
    features: [
      '2,000 credits/month',
      'All features',
      'Priority support',
      'Higher rate limits',
      'Advanced analytics',
    ],
    popular: true,
  },
}

export const CREDIT_PACKS = [
  {
    id: 'starter',
    name: 'Starter',
    credits: 100,
    price: 500,
    pricePerCredit: 0.05,
    discount: null,
  },
  {
    id: 'standard',
    name: 'Standard',
    credits: 500,
    price: 2000,
    pricePerCredit: 0.04,
    discount: '20% off',
  },
  {
    id: 'pro',
    name: 'Pro Pack',
    credits: 1500,
    price: 4500,
    pricePerCredit: 0.03,
    discount: '40% off',
    popular: true,
  },
  {
    id: 'enterprise',
    name: 'Enterprise',
    credits: 5000,
    price: 10000,
    pricePerCredit: 0.02,
    discount: '60% off',
  },
]

// Credit usage rates for different services
export const CREDIT_RATES = {
  elevenlabs: {
    name: 'ElevenLabs TTS',
    creditsPerUnit: 10,
    unit: '1,000 characters',
  },
  n8n: {
    name: 'n8n Workflow',
    creditsPerUnit: 5,
    unit: 'execution',
  },
}
